import React, { useEffect, useRef, useMemo } from 'react';
import { Point } from '../../types/pattern';
import { drawStitch } from './drawStitch';

interface StitchPreviewCanvasProps {
  position: Point;
  type: string;
  color: string;
  center: Point;
  angleOffset?: number;
  dimmed?: boolean;
}

export const StitchPreviewCanvas: React.FC<StitchPreviewCanvasProps> = ({
  position,
  type,
  color,
  center,
  angleOffset = 0,
  dimmed = false
}) => {
  const canvasRef = useRef<HTMLCanvasElement>(null);
  
  const drawingConfig = useMemo(() => {
    const dx = center.x - position.x;
    const dy = center.y - position.y;
    const angle = Math.atan2(dy, dx) - Math.PI / 2 + angleOffset;
    return { angle };
  }, [center.x, center.y, position.x, position.y, angleOffset]);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    ctx.save();
    ctx.translate(canvas.width / 2, canvas.height / 2);
    ctx.rotate(drawingConfig.angle);

    drawStitch({
      ctx,
      stitch: { type },
      color
    });

    ctx.restore();
  }, [position, type, color, drawingConfig.angle]);

  return (
    <canvas
      ref={canvasRef}
      width={40}
      height={40}
      style={{
        position: 'absolute',
        left: Math.round(position.x - 20),
        top: Math.round(position.y - 20),
        pointerEvents: 'none',
        zIndex: 1000,
        opacity: dimmed ? 0.35 : 1
      }}
    />
  );
}; 